import AdministrativeClassList from './AdministrativeClassList';

export default AdministrativeClassList; 